import { useMutation } from '@tanstack/react-query';
import { getUpdatedCaptionBrollJson } from '../../services/broll-caption/getUpdatedCaptionBrollJson';

export function useUpdatedCaptionBrollJson() {
  return useMutation(getUpdatedCaptionBrollJson, { onSuccess: (data) => data });
}
